import { isLoggedInState, AppState } from "../../components/portal/state";
import { PortalRouteParams, State, CustomRoutes, ExtraUserInfo } from "../portal_client";
import { nothing, Action, IOWidget, Widget } from "widgets-for-react";

export let get_application = 
    (application_to_render:IOWidget<AppState<State, PortalRouteParams, ExtraUserInfo>, Action<AppState<State, PortalRouteParams, ExtraUserInfo>>>) =>
    (s:AppState<State, PortalRouteParams, ExtraUserInfo>) : Widget<Action<AppState<State, PortalRouteParams, ExtraUserInfo>>> => isLoggedInState(s.login) 
        ? application_to_render(s)
        : nothing()
